// extracted by mini-css-extract-plugin
export default {"button":"styles_button__8mV0e","links":"styles_links__kCIYV","support":"styles_support__a8p-6"};